import React from 'react';

const Contacts = () => {
    return (
        <section class="pcon">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="pcon__title">
                Контакты
              </div>
              <div class="pcon__subtitle">
                Вы можете связаться с нами через форму ниже или написать нам на
                адрес <span>info@redslon.ru</span> или в личные сообщения на сайте
              </div>
              <form action="#" class="pconform">
                <div class="pconform__connect d-flex">
                  <div class="pconform-connect__item">
                    <div class="pconform-connect-item__title">
                      Ваше имя
                    </div>
                    <input
                      type="text"
                      class="pconform-connect-item__input"
                      placeholder="Дмитрий"
                    />
                  </div>
                  <div class="pconform-connect__item">
                    <div class="pconform-connect-item__title">
                      Почта для связи
                    </div>
                    <input
                      type="text"
                      class="pconform-connect-item__input"
                      placeholder="redslon@mail.ru"
                    />
                  </div>
                </div>
                <textarea name="#" class="yourmsg">Ваше сообщение</textarea>
                <div class="pcon__btns d-flex">
                  <div class="pcon__btn1"><a href="#">ОТПРАВИТЬ</a></div>
                  <div class="pcon__btn2">
                    <a href="#">НАПИСАТЬ АДМИНИСТРАТОРУ</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Contacts;
